<template>
  <div class="tbl-skeleton">
    <div v-for="r in rows" :key="r" class="tbl-skeleton__row">
      <div v-for="c in cols" :key="c" class="tbl-skeleton__cell">
        <div class="tbl-skeleton__bar" :style="{ width: barWidth(c) }" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableSkeleton',
  props: {
    rows: { type: Number, default: 6 },
    cols: { type: Number, default: 5 },
  },
  methods: {
    barWidth(c) {
      const widths = ['60%', '80%', '45%', '70%', '55%', '40%', '65%', '50%']
      return widths[(c - 1) % widths.length]
    },
  },
}
</script>

<style scoped>
.tbl-skeleton {
  padding: 8px 16px;
}
.tbl-skeleton__row {
  display: flex;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px solid rgba(0,0,0,.04);
}
.tbl-skeleton__row:last-child {
  border-bottom: none;
}
.tbl-skeleton__cell {
  flex: 1;
}
.tbl-skeleton__bar {
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: tblShimmer 1.5s ease infinite;
}
@keyframes tblShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Dark theme */
.theme--dark .tbl-skeleton__row {
  border-color: rgba(255,255,255,.04);
}
.theme--dark .tbl-skeleton__bar {
  background: linear-gradient(90deg, #22232e 25%, #2a2c3a 50%, #22232e 75%);
  background-size: 200% 100%;
  animation: tblShimmer 1.5s ease infinite;
}
</style>
